module.exports = __webpack_public_path__ + "static/media/hibachi-and-you-logo.d7a8f50e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hibachi-and-you-logo.svg
// module id = 175
// module chunks = 0